"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicColumnClient = void 0;
const BaseClient_1 = require("../BaseClient");
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
class DynamicColumnClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async addColumn(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/columns/add',
            data: request,
        });
        return response.data;
    }
    async deleteColumn(request) {
        await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/columns/delete',
            data: request,
        });
    }
    async listColumns(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/columns/list',
            data: request,
        });
        return response.data;
    }
}
exports.DynamicColumnClient = DynamicColumnClient;
